import { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { Image } from 'antd';


// import React 
// import React from "react";

// import styled from "styled-components";

import { Space, Button, Checkbox, Table as ATable, Grid } from 'antd';

import { DownloadOutlined, ReloadOutlined, DeleteOutlined, UploadOutlined, SearchOutlined } from '@ant-design/icons';

import { AgGridReact } from 'ag-grid-react';

import "ag-grid-community/styles/ag-grid.css";
import "../styles/ag-theme-custom.css";
import { Icon, Slide } from "@mui/material";
import AppContext from "antd/es/app/context";

import { downloadImageResource } from '../utils/download.js';
import Resizer from "../components/Resizer/Resizer";

const ftimg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAxiSURBVHhe7ZvZcxXHFYedSqqSVCovqZTzklIeUqEq5bdUJS95zFuekvwHroox8W7jBNspBxODhHbQwmIQiEUYQYERm22QMXCFVgRISGCbi2RLLEIIiU1CK53znZmWR337ShchJEL5uH70aGbuTJ9vTnef7hk/9Z1NtB/u3Lkz/fz582WNjY1bHwedPHmy7NSpU1uqq6uzysrK/iR1/ElQ1UdjTx8+fPiKEbt3795joYGBAdPf32/6+vrMuXPnjEBpOX78+MtS1+8HVZ5ZS/v4448v3Lx501y+fPmxUWdnp2lvbzctLS2mprZW//7qq6+OFRQU/D6s94xZ2sGDB+OPG4BLly6Zjo4O88UXX5jPP//cyEMyQ0NDpq2tbWD//v1vhnWfEXssASCe+sWLF430CWbHjh1EgLl79665ceOGOXrkSPm8efN+FvrwUPbYAiAKvv76a9Pc3Gx2795t6uvrzeDgoLl+/bq5deuWkU6yccGCBfNCP6Zt9AFxLnjlypVx+So027LNgI6QJnDkyBFz//59c/v2bdPd3W36bvaZmpqajoULF/4h9GVa5gWQTL6KPkoB4MsvvzSfffaZkbZvxsbGzMjIiLlz545C6O3tJTK6Fy1a9MfQnwe2tE8++SQO1atXr6p8jqcinwMPK/qBCxcumGPHjpmKigp1HhseHg4gXLcQ6rpfePXVaUVCAoDJ5HN8Kl2+PH04FkAsFjN79+5Vx7H7QBgZ1k6RPoGcoa6urvPZZ5/9behXyqYAoNnV1TVBPgDJ5HM8FfmcjsoCqKqqMvv27RsHgN2X/4gIIPT09GjfcOLEibPPPPPM06FvKVnap59+Guci165dS4CQTDhNyW9Skfv7VMQ9gNB2sU0BHDh4QPsAn5Ej9EoUkEFKZlshfqWcNaYdOnRoHEAydXX5naCC9NaXRZRTqzOQPFme7lT65ptvdPwHgKTDCsBGq70moBjGSaMBQVRI3rAo9G9KUwCQo1d15YOBaHdUsKRkvSkuLjKrV68KtdqsKi42hQUFpmDlSrNyxQqzIj9ft1evkuOh1si5hQUr5VienJOvKli5whQXFcrx4nFxrQI5j2wQALt27TIr5JpLliwx7777rmrx4sUmPT1d6lFsZGKn2aM0r/6MjIzfhT5OagqACQhOWXUjIEgv60JBtDkA4FhmZobJzs5Spacv03L9+nVmy+bNZtu2MlO+fbtuZ2fJOaEyly83JevXm/Ly7XrO1i2bzYYNJQpk2dL35ZxMVVZmpsnISKdtm4aGBrNnT4WRGaIpLS1Vbdq0ScuSkhKzSsDm5uaaLLk+w6aMHAfFvx8Ebia3tMrKyjjhg1MIAD0RGK4sAMKPp58rDufn5YpTGep4PH5B01WGJ3pnQra9vU0ql6PKk3OXi1M4ROT13ujV87lmh0Al7c2QJ5onzuTm5CgI0uF4PG5kmkzyo00CAQbFYlU6VIov5sCBA2a7QKdcunTpn0M/k1qa0IqTYtpKTKYAQo+eS/snRHOys/WprhIYtG164ygsQFyQdpwXBbA83dTW1mjbjTYtrovKtpbpk+d8ADQ1NWlbb29rVxCMDIht+zcJE1kjqTNw+Y1ExbrQz6SmAOg87M296pkIB6cYxlZJOyXkCdXmpubxcTkqooAKAgBptIhzdTLNJQO1zcpC4NpkgPQRWTQFuX7L2bN632DoFCUZRm3HKbNG2b5kPtz+YaP4+NPAVb+lSY6tAHp7+/TmCSJEeycCwSmeCB1V+rKlMlnZNT4eu7opOXsAIFeVn5cnTSCDxCWIlhBAVDSb2PGYNIVlEmFZprW1ResSjRar6KhEnRBwuLc0gzbx8ZeBq35TACQYOOUqAUYoQpcbFhcVaYgShlQ6CgkFAG7pcUIf5UtHt1z6C2Z30eYSFb8FxNo1a8xy6Q9aW1u1Pi4oKx8Yoks6+Ivi468CV/2WdvTo0fjIyKg65UpB2DIiLg4AHNomvTJP34WEE70SOZzLvJ7QR/T0dJj1DfUKLRot4xIIXPOI9Ob/lSEPANQnCgnHbemK/cCVpIgImBrA2NioVtQVN70VwnCFk4Q2bY9zo4A41heCoCK0SUIfWQANAgAnoxGDLAR+29V1VTs2wtoei0JIJs7j2g8AYEwrGhVO2dIVACgZxniKLhwFIW2fMhgG2zX0AwD5mgectMNgCArhpC0Rv6cO7LNgopBcTQuAjJ9xFhqoqBU3taVPCuJ2Ihhk4VgYVISVHZ68SrK+zEwBIGM7CZiNmr5knXAoF44rnLajFX8DV/KC1AAwoaCi47pzdwKQqABgS1e3bBkB0t8/IEPTtwBIe7MEQGNjo+bv0aixpSscnwyQC4N9wJUhfmoAkmMrAIihCSC88oNBLhA0IE52yNjsAjh1qlHX+CwoC8InBRE2KVcuDMR+4MoINzUASSkVAMTsS4n+gQCGqwCAHxIAbBnVPXGSxIa2j5ggkTidlrSW/ANIALClK4VgS49w9mYEiP4t+4H7QADsWxlb+tSPkoLxi4ooAHnyaKXM+sjwTp8+rQscOA4oGzGugHA7AiQqHLVlVOwDbkoAZDKhAAbvDaoAkKCBEE4ERlRAsKWr4eEhTVGj016SpzNnzoyv6LhRYwUAW7rCSVv6NDw0bI4dPTY1gOrqAMDQ4JA+LZ/uDXqghBoQOEHphzMyMqy5AqGPmEIzeWKyMjo6lhAxVjhuS59cIBMkx4ErHXwqAKoDAEKMsIlqcBIoiPY9OCkcAIwGAOTJIxY4mOA0NzeZMRl+fVGDXCBRAcCWPt0VjY6OsoiSOgDaY1QuDFcAGIrAcAUASirC5ITQR8zymOCcFQDkH27EWCXtb/r9UKwUgJQkdykBqKmpUQCEDMJ5W3rlgeEKx21JRUhlCX3EclkAoJnbJkQNAsB0+hsLgW3gxmKxqQHU1tYqAJ4UsiB8AoAtfXJBICpCTk/ofwsg25yVOT5mI8bKB8QKx23pE47bbUxGuAcHkChxHjkwJmg4hCLbLhSMmaMCEBUWCoCcbNPSEgCwoFwQrnDclj7hdLTEUgJQV1enAAjVcUnvTOkHEtWIll4ooTCW1Wn7qEgA5AqA1pYWPcYwGY0Yn3Dclj7hsC3tNiZD/DQBTKFEEInCeUqMBYoEAK0BAM5zo8bKNzK5ioKwYj8mHXzqAGiryeSDkKDxqJkICAsAFKiKCgtDAK16LBotUQHAlj65IKLiODZjACZTAghHGHN02v63AHLM+fPn9VgU1qjkDJQuDFc4aMtkwlIC0NDQoAB85nM4FbkAWKYiCQJCUVGhJkKsB2DBeREISaTO2zKZws6YbUw6+IcDkNTuJ4fjGvtY22NJnFdfAAAGb4IYHVyLwlM5IHzCYVvabUyi+xEBmMS4OeFdX1dnKisPmw+3bdPFUDo/K0CwNkCnuHNHuQI6c+b0eAKTACGJLABXHMPmBADjMAlP+rJlOu+nvdss0KbDVswOyQpZJOX9Qmdnh14jGlFWzBtcAD7RCVNicwKAm9Prk/4S4pOLc0T6QuOK9uCYD8BkGhubCId9WH19/ewDeBSmDkUcnkrWxLcnA0Ay8zmPrD3xAKay7wB8B2AOANCT22kpYzJGdnb1iv5vCWqM9/YY2xy3i5ms6rKuNxM26wCGhgbN0vffNwvfeN288dprpr2tTV+hLV78H/PCPxbo90AYH1Rt2bJZt0mKTlRV6VrBq6+8bF556UWz7oO1euxhbdYB8ORxdP/+ffqlBmnp2rVr9POZazLuPz//OZ0XrPvgAzP/ub/r8dycLJm3V+lCJt8OlW3dotszYXMC4KUXXzDnzgVTXexf/3xTP4bA3n5rkamKxcyO8nIFwBtivjKpqanW42SGeyv26vZM2KwDYDGC8OfTlo0bN2iGh9N29WfJkvfM4UOHdH6wds1qFVNkC4D5wZ6PPtLtmbA5A0D+z/eBN3p6zL/feds0hlPfd95+SyNg44YNpqoqpgA43x7/vwdgmwAvPawx2cFhevYFz8/XeQJfi+I0TeNvf/2LvibDmDJ/tHu3bs+EzQkAOjq+AbTG1yFvvP6aeVl6902lpbqPKXF19Qkd/gDGtwIYr84q9uzR7ZmwWQdAE1jy3mLT1BQ8UWu8s+d7Imt8P8T4j3HMruOzzZudmbJZB4CR4EQnJHNpKQGQ9nc1PP+JM/GtW3ycFMAvNm7cuKaysvKwGP88McKn0tLStfgYuOq3H4t+Lvq16DdPmPAJ334kmtS+94QrYk899T9JtrmAU9E60AAAAABJRU5ErkJggg==";

function ResourcesPanel(props) {

    // https://www.ag-grid.com/react-data-grid/getting-started/
    const gridRef = useRef();

    useEffect(() => {
        console.log("ResourcesPanel::componentWillMount() " + window.PSMan);

        window.PSMan_onResourceEvents = function (nm, obj) {
            console.log("PSMan_onResourceEvents()>>>>>>:: ", nm, obj);

            updateRowData();
        }

        return () => {
            console.log("ResourcesPanel::componentWillUnmount()");
            // Anything in here is fired on component unmount.
            delete window.PSMan_onResourceEvents;
        }
    }, [])



    const updateRowData = () => {

        let flist = window.PSMan.getInstance().resourceManager().list("/psman");

        console.log("ResourcesPanel flist", flist);

        var fflist = flist;
        var rowData = fflist.map((item, idx) => ({
            key: idx,
            id: idx,
            path: item.path,
            url: item.name,
            real_name: item.name,
            name: item.name
        }));

        setRowData(rowData);
    }


    const [rowData, setRowData] = useState([]);

    const [selectedId, setSelectedId] = useState(-1);


    function ThumbnailComponent(props) {

        const [imgURL, setImgURL] = useState();

        useEffect(() => {

            let imp = props.data.path;
            let ext = imp.slice(-4).toLowerCase();
        
            if (ext == ".ttf" || ext == ".otf") {
                setImgURL(ftimg);
            } else {

                let openRequest = window.indexedDB.open("/psman", 21);
                openRequest.onerror = function (event) {
                    console.log("打开IndexedDB('/psman', 21) 失败!!", event);
                };
                openRequest.onsuccess = function () {
                    let db = openRequest.result;
                    // 继续使用 db 对象处理数据库
    
                    var transaction = db.transaction(["FILE_DATA"]);
                    var objectStore = transaction.objectStore("FILE_DATA");
                    var request = objectStore.get(imp);
                    request.onerror = function (event) {
                        console.log("Unable to retrieve daa from database!");
                        // return "";
                    };
                    request.onsuccess = function (event) {
                        var imgFile = request.result;
                        let blob = new Blob([imgFile.contents], { type: "image/png" });
                        let urlObj = window.URL.createObjectURL(blob);
                        setImgURL(urlObj);
                    };
                };
            }


        }, [props.data.path]);


        return (
            <>
                {imgURL && <Image style={{ objectFit: "contain", height: "100%" }} width={50} src={imgURL} />}
            </>
        );
    }

    function operateComponent(props) {
        return (
            <div style={{ display: "flex", alignItems: "left", height: "100%" }}>
                <Button type="text" style={{ height: "100%" }} icon={<DownloadOutlined />}
                    onClick={() => downloadButtonClick(props)}></Button>

                <Button type="text" style={{ height: "100%" }} icon={<DeleteOutlined />}
                    onClick={() => deleteButtonClick(props)}></Button>
            </div>
        );
    }

    const [columnDefs] = useState([
        {
            headerName: 'thumbnail',
            cellRenderer: ThumbnailComponent,
            width: 42,
            cellStyle: {
                display: 'flex',
                alignItems: 'left',
            }
        },
        {
            headerName: 'Name',
            field: 'name',
            width: 156,
            cellStyle: {
                display: 'flex',
                alignItems: 'center',
            }
        },
        {
            headerName: 'operate',
            cellRenderer: operateComponent,
            width: 100,
            cellStyle: {
                display: 'flex',
                alignItems: 'center',
            }
        }
    ]);


    const deleteButtonClick = (props) => {
        console.log("deleteButtonClick = ", props);
        var path = "/psman/" + props.data.real_name;
        window.PSMan.getInstance().resourceManager().delete(path, () => { updateRowData(); });
    }

    const downloadButtonClick = (props) => {
        var path = "/psman/" + props.data.real_name;
        let img = window.PSMan.getInstance().resourceManager().load(path);
        downloadImageResource(props.data.name, img);
    }

    const onRowDataUpdated = (e) => {
        let agridapi = gridRef.current.api;

        console.log("+++++++++++= : ", agridapi);
        console.log("+++++++++++=  ID : ", selectedId);

        agridapi.forEachNode((rowNode, index) => {
            // console.log("-------------: ", rowNode);
            if (rowNode.data.id == selectedId) {
                // console.log("-------------: ", rowNode);
                rowNode.setSelected(true);
            }
        });
    };

    const refreshResource = () => {
        updateRowData();
    }

    const uploadButtonClick = () => {
        let _filesInput = document.getElementById("filesInput");
        _filesInput.click();
    }

    const handleChangeFile = (e) => {

        let filename = e.target.files[0].name;
        // let filepath = e.target.files[0].
        console.log("input file: " + filename);
        var file = e.target.files[0];
        var reader = new FileReader();

        // reader.readAsText(file);
        reader.readAsArrayBuffer(file);
        reader.onload = function () {

            var arrayBuffer = reader.result;

            // var u8arrayBuffer = new Uint8Array(arrayBuffer);
            console.log("array buffer: ", arrayBuffer);
            // console.log("array buffer: ", u8arrayBuffer);

            // let savnam = "/psman/_res_img_" + filename;
            let savnam = "/psman/" + filename;
            window.PSMan.getInstance().resourceManager().save(savnam, arrayBuffer, () => { updateRowData(); });
            console.log("save image :", savnam);
        }
    }


    return (
        <>
            <Resizer maxHeight={450} minHeight={100}>
            <div className="ag-theme-custom-dark" style={{ height: 200 }}>
                <AgGridReact className="resource-grid" ref={gridRef} rowData={rowData} columnDefs={columnDefs}
                    suppressHorizontalScroll={true}
                    suppressCellFocus={true}
                    suppressMovableColumns={true}
                    suppressRowClickSelection={false}
                    headerHeight={0}
                    rowHeight={40}
                    rowDragManaged={true}
                    animateRows={true}
                    rowSelection="single"
                    onRowDataUpdated={onRowDataUpdated} />
            </div>
            </Resizer>

            <Space>
                <Button type="text" icon={<ReloadOutlined />} onClick={refreshResource} />
                <Button type="text" icon={<UploadOutlined />} onClick={() => uploadButtonClick()} />
            </Space>

            <input id="filesInput" type="file" accept=".jpg,.png,.ttf,.otf,.3dl,.cube" style={{ display: "none", height: 0 }}
                onChange={(e) => handleChangeFile(e)} />

        </>
    );
}


export default ResourcesPanel;